/**
 * 日志输出
 * @author lianghua.fu
 * @date 2020-10-14 11:52:52
 */
import debug from 'debug'
import storage from './storage'

const create = (name:string) => {
    name = 'app:' + name

    let items:Array<string> = storage.getItem('APP_DEBUG') || [];
    if (items.indexOf(name) < 0) {
        items.push(name)
        storage.setItem('APP_DEBUG', items)
    }

    return debug(name);
}

const error = create('err');
const log = create('log');


export {
    log,
    create,
    error
}

export default log
